import { find } from 'lodash';
import { createSelector } from 'reselect';
export const getTags = (state) => state.tags ?? [];
export const getMostPopularTags = (state) => state.mostPopularTags;
export const getTagBySlug = createSelector([getTags, (_, tagSlug) => tagSlug], (tags, tagSlug) => find(tags, (tag) => tag.slug === tagSlug));
//# sourceMappingURL=tags-selectors.js.map